export enum ResponseRegion {
    EU = 1,
    NA
}
